import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
const PaymentMenu = ({ activeItem, onClick, isWalletEnabled, isScheduledPaymentEnabled }) => {
	return (
		<Menu pointing secondary stackable>
			<Menu.Item id="paymentsPoliciesBtn" name='policies' active={activeItem === 'policies'} icon='list layout' onClick={onClick} />
			<Menu.Item id="paymentsPastPaymentsBtn" name='past payments' active={activeItem === 'past payments'} icon='calendar' onClick={onClick} />
            <Menu.Item id="paymentsRecurringPaymentsBtn" name='monthly recurring payments' active={activeItem === 'recurring payments'} icon='refresh' onClick={onClick} />

            {isWalletEnabled &&
                <Menu.Item id="paymentsWalletBtn" name='wallet' active={activeItem === 'wallet'} icon='credit card' onClick={onClick} />
            }

			{isScheduledPaymentEnabled &&
				<Menu.Item id="paymentsScheduledPaymentsBtn" name='scheduled payments' active={activeItem === 'scheduled payments'} icon='calendar alternate' onClick={onClick} />
			}
			
			<Menu.Menu position='right'>
				<Menu.Item id="paymentsPayNowBtn" name='pay now' icon='credit card alternative' onClick={onClick} />
			</Menu.Menu>
		</Menu>
	);
};

PaymentMenu.propTypes = {
	activeItem: PropTypes.string,
	onClick: PropTypes.func.isRequired
};

export default PaymentMenu;
